"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

require("sweetalert2/dist/sweetalert2.min.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.Vue = require("vue");

var swalPlugin = {};

swalPlugin.install = function (Vue) {
  Vue.prototype.$swal = _sweetalert2.default;
};

exports.default = swalPlugin;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/plugins/VueSweetalert2.js
// module id = FpL5
// module chunks = 0 1